import {useMemo} from "react";
import {ReachTemplateOption} from "../../apis/requests/templates/types";
import {useGetTriggerTemplates} from "../../apis/requests/triggers/getTriggerTemplates";
import {TemplateChannels} from "./helpers";

export const useTriggerTemplates = () => {
  const {data, isLoading} = useGetTriggerTemplates();

  return useMemo(() => {
    const templates: ReachTemplateOption[] = data ?? [];
    const channels: TemplateChannels = new Map(templates.map((t) => [t.id, t.content_channel]));
    return {templates, channels, isLoading};
  }, [data, isLoading]);
};
